import { render, staticRenderFns } from "./ArticleLanding.vue?vue&type=template&id=72302f89&"
import script from "./ArticleLanding.vue?vue&type=script&lang=js&"
export * from "./ArticleLanding.vue?vue&type=script&lang=js&"
import style0 from "./ArticleLanding.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports